// Generated by LiveScript 1.6.0
var ref$, id, log, findInside, Widgets, allWidgets, genWid, getWidgetById, getWidgetAtDom, initAllWithin, initWidget, out$ = typeof exports != 'undefined' && exports || this;
ref$ = require('utils'), id = ref$.id, log = ref$.log, findInside = ref$.findInside;
Widgets = {
  'servd': require('./servd'),
  'slideshow': require('./slideshow'),
  'resdiary-show': require('./resdiary-show')
};
allWidgets = {};
genWid = function(i){
  i == null && (i = 0);
  return function(){
    return i += 1;
  };
}();
out$.getWidgetById = getWidgetById = function(id){
  return allWidgets[id];
};
out$.getWidgetAtDom = getWidgetAtDom = function(el){
  return getWidgetById($(el).attr('data-widget-id'));
};
out$.initAllWithin = initAllWithin = function(subdom){
  return [].reverse.apply($('[data-widget]', subdom)).toArray().forEach(initWidget);
};
out$.initWidget = initWidget = function(el){
  var $el, config, types, i$, len$, type;
  $el = $(el);
  config = $el.data();
  types = config.widget.split(' ');
  for (i$ = 0, len$ = types.length; i$ < len$; ++i$) {
    type = types[i$];
    if (Widgets[type]) {
      config.id = genWid();
      allWidgets[config.id] = new Widgets[type]($el, config, findInside(el));
      $el.attr('data-widget-id', config.id);
    } else {
      console.warn('No such widget:', type);
    }
  }
  return allWidgets[config.id];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmxzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBS0EsSUFBQSxHQUEyQixPQUEzQixDQUFtQyxPQUFBLENBQW5DLEVBQUUsRUFBdUIsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQSxFQUFBLEVBQU0sR0FBbUIsQ0FBQSxDQUFBLENBQXpCLElBQUEsQ0FBQSxHQUFBLEVBQVcsVUFBYyxDQUFBLENBQUEsQ0FBekIsSUFBQSxDQUFBO0FBT0EsT0FBUSxDQUFBLENBQUEsQ0FDTjtFQUFBLFNBQWlCLFFBQVEsU0FBQTtFQUN6QixhQUFpQixRQUFRLGFBQUE7RUFDekIsaUJBQWlCLFFBQVEsaUJBQUE7QUFGekI7QUFTRixVQUFZLENBQUEsQ0FBQSxDQUFFO0FBRWQsTUFBUSxDQUFBLENBQUEsQ0FBSyxRQUFBLENBQUEsQ0FBQSxDQUFILENBQUE7QUFBQSxFQUFJLENBQUosUUFBQSxDQUFBLEVBQUEsQ0FBQSxDQUFJLENBQUosQ0FBQSxDQUFBLENBQVEsQ0FBUixDQUFBLENBQUE7QUFBQSxFQUFBLE1BQUEsQ0FBYyxRQUFBLENBQUEsQ0FBZCxDQUFBO0FBQUEsSUFBQSxNQUFBLENBQWlCLENBQUUsQ0FBQSxFQUFBLENBQUcsQ0FBdEIsQ0FBQTtBQUFBLEVBQUEsQ0FBQSxDQUFBO0FBQUEsQ0FBQSxDQUFBO3FCQUVILGFBQWlCLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxFQUFBO1NBQ3hCLFVBQVcsQ0FBRSxFQUFGOztzQkFFTixjQUFrQixDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsRUFBQTtTQUN6QixjQUFpQixFQUFFLEVBQUQsQ0FBSSxDQUFDLEtBQUssZ0JBQUEsQ0FBWDs7cUJBRVosYUFBZ0IsQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLE1BQUE7U0FDdkIsRUFBRSxDQUFDLE9BQU8sQ0FBQyxNQUFPLEVBQUUsaUJBQWlCLE1BQWxCLENBQUgsQ0FBOEIsQ0FBQyxRQUFPLENBQUMsQ0FBQSxRQUFTLFVBQUE7O2tCQU8zRCxVQUFZLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxFQUFBOztFQUNuQixHQUFPLENBQUEsQ0FBQSxDQUFFLEVBQUUsRUFBRDtFQUNWLE1BQU8sQ0FBQSxDQUFBLENBQUUsR0FBRyxDQUFDLEtBQUk7RUFDakIsS0FBTyxDQUFBLENBQUEsQ0FBRSxNQUFNLENBQUMsTUFBTSxDQUFDLE1BQU0sR0FBQTtFQUU3QixpREFBQTtJQUFJO0lBQ0YsSUFBRyxPQUFPLENBQUMsSUFBRCxDQUFWO01BQ0UsTUFBTSxDQUFDLEVBQUcsQ0FBQSxDQUFBLENBQUUsT0FBTztNQUNuQixVQUFXLENBQUMsTUFBTSxDQUFDLEVBQVIsQ0FBWSxDQUFBLENBQUEsS0FBTSxPQUFPLENBQUMsSUFBRCxFQUFPLEtBQUssUUFBUSxXQUFZLEVBQUQsQ0FBekI7TUFDMUMsR0FBRyxDQUFDLEtBQUssa0JBQWlCLE1BQU0sQ0FBQyxFQUF4QjtLQUNYO01BQ0UsT0FBTyxDQUFDLEtBQUssbUJBQW1CLElBQXBCOzs7U0FFaEIsVUFBVyxDQUFDLE1BQU0sQ0FBQyxFQUFSIiwic291cmNlc0NvbnRlbnQiOltudWxsXX0=

